export const environment = {
  showDefaultLogin: false,
  production: true,
  baseUrl: 'https://apibeta.plataformaesa.com.br',
  recaptcha: {
    siteKey: '6LexkkggAAAAANuv-R_j33l4wFj1H4uf1ek9e039'
  }
};
